import { IncidenciaUsuarioCampoCustom, IncidenciaUsuarioCategoriaCustom, SaveIncidenciaUsuarioCampoCustom } from "./incidenciaUsuarioCategoria";

export class IncidenciaUsuario {
    constructor (
        public readonly Id: number,
        public readonly FechaCreacion: Date,
        public readonly FechaLimite: Date | null,
        public readonly UsuarioAsignadoId: number | null,
        public readonly UsuarioAsignadoNombre: string | null,
        public readonly UsuarioAsignadoApellido: string | null,
        public readonly UsuarioAsignadoLogin: string | null,
        public readonly UsuarioCreadorId: number | null,
        public readonly UsuarioCreadorNombre: string | null,
        public readonly UsuarioCreadorApellido: string | null,
        public readonly UsuarioCreadorLogin: string | null,
        public readonly IncidenciaUsuarioCategoriaId: number | null,
        public readonly IncidenciaUsuarioCategoriaNombre: string | null,
        public readonly IncidenciaUsuarioCategoriaPadreId: number | null,
        public readonly IncidenciaUsuarioCategoriaPadreNombre: string | null,
        public PersonaId: number | null,
        public readonly PersonaNombreCompleto: number | null,
        public readonly Asunto: string | null,
        public readonly ComunidadId: number | null,
        public readonly ComunidadNombre: string | null,
        public readonly ProveedorId: number | null,
        public readonly ProveedorNombre: string | null,
        public readonly PedidoId: number | null,
        public readonly ContratoId: number | null,
        public readonly Contrato: string | null,
        public readonly UnidadFuncionalId: number | null,
        public readonly UnidadFuncional: string | null,
        public readonly EstadoId: number | null,
        public readonly EstadoNombre: string | null,
        public readonly Editable: boolean,
        public  Destinatarios: string | null,
        public IncidenciaUsuarioCampoCustom: IncidenciaUsuarioCampoCustom[],
        public IncidenciaUsuarioCategoriaCustom: IncidenciaUsuarioCategoriaCustom[]
    ) {}
}

export class IncidenciaCantidadNoLeidosUsuarioDto {
    constructor (
        public readonly Total: number
    ) {}
}

export class SearchIncidenciaUsuarioRequestDto {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Id: number | null,
        public readonly UsuarioCreadorId: number | null,
        public readonly FechaCreacionDesde: Date | null,
        public readonly FechaCreacionHasta: Date | null,
        public readonly FechaLimite: Date | null,
        public readonly IncidenciaUsuarioCategoriaId: number | null,
        public readonly ComunidadId: number | null,
        public readonly ProveedorId: number | null,
        public readonly PedidoId: number | null,
        public readonly PersonaId: number | null,
        public readonly ContratoId: number | null,
        public readonly UnidadFuncionalId: number | null,
        public readonly Estados: string | null,
        public readonly UsuarioCreador: string | null,
        public readonly Asunto: string | null,
        public readonly VerSoloNoLeidos: boolean | null
    ){}
}

export class SearchIncidenciaUsuarioResponseDto {
    constructor(
        public readonly count: number,
        public readonly result: SearchIncidenciaUsuarioItemDto[]
    ){}
}

export class SearchIncidenciaUsuarioItemDto {
    constructor(
        public readonly Id: number,
        public readonly UsuarioCreadorId: number,
        public readonly UsuarioCreadorNombre: string | null,
        public readonly UsuarioCreadorLogin: string | null,
        public readonly UsuarioNombre: string | null,
        public readonly UsuarioLogin: string | null,
        public readonly Asunto: string | null,
        public readonly ComunidadId: number,
        public readonly EstadoId: number,
        public readonly FechaCreacion: Date,
        public readonly FechaEnvio: Date,
        public readonly Leido: boolean,
        public readonly Enviado: boolean,
        public readonly FechaLeido: Date | null
    ){}
}

export class SaveIncidenciaUsuario {
    constructor (
        public readonly Id: number | null,
        public readonly Asunto: string | null,
        public readonly Mensaje: string | null,
        public readonly IncidenciaUsuarioCategoriaId: number | null,
        public readonly ComunidadId: number | null,
        public readonly EstadoId: number | null,
        public readonly FechaLimite: Date | null,
        public readonly UsuarioAsignadoId: number | null,
        public readonly PersonaId: number | null,
        public IncidenciaUsuarioCampoCustoms: SaveIncidenciaUsuarioCampoCustom[],
        public Adjuntos: IncidenciaHiloAdjunto[],
        public NuevosAdjuntosBorrados: string[]
    ) {}
}

export class UploadIncidenciaUsuarioAttachResponseDto {
    constructor (
        public readonly Archivos: IncidenciaHiloAdjunto[]
    ) {}
}

export class IncidenciaHilo {
    constructor (
        public readonly Id: number,
        public readonly IncidenciaId: number,
        public readonly FechaCreacion: Date,
        public readonly FechaEnvio: Date,
        public readonly UsuarioCreadorId: number,
        public readonly Mensaje: string | null,
        public readonly Leido: boolean,
        public Adjuntos: IncidenciaHiloAdjunto[],
        public MensajeHtml: any
    ) {}
}

export class IncidenciaHiloDto {
    constructor(
        public Incidencia: IncidenciaUsuario,
        public Mensajes: IncidenciaHilo[]
    ){}
}

export class IncidenciaHiloAdjunto {
    constructor (
        public readonly Id: number,
        public readonly NombreDocumento: string | null,
        public readonly UrlDocumento: string | null,
        public readonly IncidenciaHiloId: number,
        public readonly IncluidoEnCuerpoMensaje: boolean
    ) {}
}

export class SearchIncidenciaHiloRequestDto {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly VerEnviados: boolean | null,
        public readonly FechaCreacionDesde: Date | null,
        public readonly FechaCreacionHasta: Date | null,
        public readonly UsuarioCreador: string | null,
        public readonly Asunto: string | null,
        public readonly VerSoloNoLeidos: boolean | null
    ){}
}

export class SearchIncidenciaHiloResponseDto {
    constructor(
        public readonly count: number,
        public readonly result: SearchIncidenciaHiloItemDto[]
    ){}
}

export class SearchIncidenciaHiloItemDto {
    constructor(
        public readonly Id: number,
        public readonly IncidenciaId: number,
        public readonly Leido: boolean,
        public readonly FechaLeido: Date,
        public readonly Mensaje: string | null,
        public readonly UsuarioCreadorId: number,
        public readonly UsuarioCreadorLogin: string | null,
        public MensajeHtml: any,
        public Adjuntos: IncidenciaHiloAdjunto[]
    ){}
}

export class IncidenciaHiloResumenDto {
    constructor(
        public readonly Id: number,
        public readonly UsuarioCreadorNombre: string | null,
        public readonly UsuarioCreadorImagenUrl: string | null,
        public readonly Asunto: string | null,
        public readonly FechaEnvio: Date,
        public readonly Leido: boolean
    ){}
}

export class SaveIncidenciaHilo {
    constructor (
        public readonly IncidenciaHiloId: number | null,
        public readonly IncidenciaId: number | null,
        public readonly Mensaje: string | null,
        public Adjuntos: IncidenciaHiloAdjunto[],
        public NuevosAdjuntosBorrados: string[]
    ) {}
}

export class UploadIncidenciaHiloAttachResponseDto {
    constructor (
        public readonly Archivos: IncidenciaHiloAdjunto[]
    ) {}
}

export class SendIncidenciaUsuarioNotificationDto {
    constructor (
        public readonly mensajeUsuarioId: number,
        public readonly usuarioOrigen: string | null,
        public readonly asunto: string
    ) {}
}

export class ViewHilosRequestDto {
    constructor (
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly IncidenciaId: number
    ) {}
}

export class IncidenciaUsuarioDashboardDto {
    constructor (
        public readonly Id: number,
        public readonly FechaLimite: number,
        public readonly UsuarioAsignadoId: number,
        public readonly UsuarioAsignadoNombre: number,
        public readonly UsuarioAsignadoApellido: number,
        public readonly UsuarioAsignadoLogin: number,
        public readonly IncidenciaUsuarioCategoriaId: number,
        public readonly IncidenciaUsuarioCategoriaNombre: number,
        public readonly Asunto: number,
        public readonly EstadoId: number,
        public readonly EstadoNombre: number
    ) {}
}
